import { IRecommendedServicePackageServiceSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { mapServiceType } from '../../../../utils/publishTerms';

export const mapRecommendedPackageService = (
  service: IRecommendedServicePackageServiceSchema,
): IRecommendedPackageService => {
  const { count, price, auctionPoints, durationInDays } = service;

  const serviceType = service.serviceType as string;

  return {
    serviceType: mapServiceType(serviceType)!,
    count,
    price,
    auctionPoints,
    durationInDays,
  };
};
